<template>
  <button :class="{'btn-sm': small}" class="btn btn-secondary" type="button"
          @click.prevent="confirmActive = !confirmActive">
    <template v-if="confirmActive">
      <div class="pop-cover">
        <div class="undo-popover bg-danger">
          {{ text ? text : 'Are you sure you want to undo?' }}
          <button class="btn btn-primary btn-sm mx-2 px-2 py-0" @click.prevent="executeAction">Yes</button>
          <button class="btn btn-secondary btn-sm px-2 py-0">No</button>
        </div>
      </div>
    </template>

    <fa icon="undo"/>
  </button>
</template>

<script>
import axios from 'axios'

export default {
  name: 'v-undo',
  props: {
    url: {
      type: String,
      default: ''
    },
    method: {
      type: String,
      default: 'post'
    },
    small: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    }
  },

  data: () => ({
    confirmActive: false
  }),

  methods: {
    executeAction() {
      if (this.url != '') {
        axios
          .request({method: this.method, url: this.url})
          .then((response) => {
            this.confirmActive = false
            this.$notify({
              title: this.$i18n.t('sandoz.successfully_undo'),
              text: this.$i18n.t('sandoz.successfully_undo_text')
            })
            this.$emit('action-executed')
          })
          .catch((error) => {
            console.log(error)
          })
      } else {
        this.$emit('execute-action')
      }
    }
  }
}
</script>

<style scoped>
.pop-cover {
  position: relative;
}

.undo-popover {
  position: absolute;
  right: 32px;
  padding: 10px;
  border-radius: 4px;
  min-width: 180px;
  bottom: -30px;
}
</style>
